/**
 * 配置上传文件、图片、视频的公共链接地址
 * 
 * baseurl: 上传地址
 */
let baseurl = process.env.BASE_API
let algorithmURL = 'https://fzflw1.cnfzflw.com/'
let algorithmLocalURL = 'http://192.168.0.186:8001/'
// let algorithmCeshi = 'http://121.41.88.48:8002/' 
let algorithmCeshi = 'https://fzflw2.cnfzflw.com/'

// 个人中心-发布采购信息/会员服务选择会员中的图片上传地址
let imgUpload_public = baseurl + 'index/person/picUpload'	
// 个人中心-发布供应信息CAD图片上传地址
let imgUpload_cad = baseurl + 'index/person/cadUpload'	
// 图搜搜上传搜索图片的地址
let imgSearchUrl = baseurl + 'index/algorithm/upload_search_img'

// 以下为与算法对接部分

// 个人中心-发布供应信息上传图片--获取坐标
let imgUpload_extra_location = algorithmCeshi + 'extra_location'
let imgUpload_extra_location_lalian = algorithmCeshi + 'extra_location_lalian'
// 个人中心-发布供应信息----生成bin文件
// let imgUpload_extra_bin = algorithmLocalURL + "extra_bin"
let imgUpload_extra_bin = algorithmCeshi + "extra_bin"
let imgUpload_extra_bin_lalian = algorithmCeshi + "extra_bin_lalian"
// 个人中心-发布供应信息一步生成bin文件---暂时不用
let imgUpload_extra = algorithmCeshi + "extra"
let imgUpload_extra_lalian = algorithmCeshi + "extra_lalian"

// 搜索图片--已有图片和坐标
// let search_result = algorithmLocalURL + 'search_result'
let search_result = algorithmCeshi +  'search_result'
let search_result_lalian = algorithmCeshi +  'search_result_lalian'
// 搜索图片--一步生成--接口图片及返回坐标
// let search = algorithmLocalURL + 'search'
let search = algorithmCeshi +  'search'
let search_lalian = algorithmCeshi +  'search_lalian'
// 获取坐标时的图片存放路径---获取图片时传算法额外参数
let image_path = '/data/wwwroot/vue/public/imgs/fuliaowang'
// 获取坐标时的图片存放路径---获取图片时传算法额外参数
let image_path_preset = '/data/wwwroot/vue/public/imgs/preset_goods'
// 获取坐标时的图片存放路径---获取图片时传算法额外参数
let image_path_product = '/data/wwwroot/vue/public/imgs/tracking'
// 发布产品提取图片bin文件存放路径
let bin_path = '/mnt/vdb1/lost+found/return_result'
// 产品预设提取图片bin文件存放路径
let bin_path_preset = '/mnt/vdb1/lost+found/preset_goods/button'
// 订单新增产品提取图片bin文件存放路径
let bin_path_product = '/mnt/vdb1/lost+found/tracking/button'

// 如果是生产环境
if (baseurl == 'https://www.cnfzflw.com/') {
	imgUpload_extra_location = algorithmURL + 'extra_location'
	imgUpload_extra_location_lalian = algorithmURL + 'extra_location_lalian'
	imgUpload_extra_bin = algorithmURL + "extra_bin"
	imgUpload_extra_bin_lalian = algorithmURL + "extra_bin_lalian"
	imgUpload_extra = algorithmURL + "extra"
	imgUpload_extra_lalian = algorithmURL + "extra_lalian"

	search_result = algorithmURL +  'search_result'
	search_result_lalian = algorithmURL +  'search_result_lalian'
	search = algorithmURL +  'search'
	search_lalian = algorithmURL +  'search_lalian'
	image_path = '/data/wwwroot/cnfzflw/public/imgs/fuliaowang'
	image_path_preset = '/data/wwwroot/cnfzflw/public/imgs/preset_goods'
	image_path_product = '/data/wwwroot/cnfzflw/public/imgs/tracking'
	bin_path = '/mnt/vdb1/algorithm/return_result'
	bin_path_preset = '/mnt/vdb1/algorithm/preset_goods/button'
	bin_path_product = '/mnt/vdb1/algorithm/tracking/button'
}

export {
  	imgUpload_public,
  	imgSearchUrl,
  	imgUpload_cad,
  	imgUpload_extra_location,
	imgUpload_extra_bin,
	imgUpload_extra,
  	imgUpload_extra_location_lalian,
	imgUpload_extra_bin_lalian,
	imgUpload_extra_lalian,
	image_path,
	image_path_preset,
	image_path_product,
	bin_path,
	bin_path_preset,
	bin_path_product,
	search_result,
	search,
	search_result_lalian,
	search_lalian
}



// WEBPACK FOOTER //
// ./src/config/env.js